var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":_vm.viewBox}},[_c('g',{attrs:{"fill":_vm.color,"transform":"rotate(-180.000032 21.215 3.375)"}},[_c('rect',{attrs:{"width":"1.52","height":"37","x":"20.45","y":"-17.84","rx":"0","ry":"0"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M24.59 19.16h-6.75l3.37 5.43 3.38-5.43z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }